import React, { useCallback, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { Link } from '@material-ui/core';
import announceIcon from '../../../../assets/images/announce.svg';
import cancelIcon from '../../../../assets/images/cancel.svg';
import styles from './OverduePrompt.module.less';

const OverduePrompt = ({
  overdueDays,
  isShowOverduePrompt,
  isLogin,
  toggleOverduePrompt
}) => {
  const isShow = useMemo(() => {
    return isLogin && isShowOverduePrompt;
  }, [isLogin, isShowOverduePrompt]);

  const hideOverduePrompt = useCallback(() => {
    toggleOverduePrompt({ isShowOverduePrompt: false });
  }, [toggleOverduePrompt]);

  if (!isShow) {
    return null;
  }

  return (
    <div className={styles['overdue-prompt']}>
      <div className={styles['tip-wrap']}>
        <img src={announceIcon} alt={announceIcon} />
        <span className={styles.tip}>
          {`Your password will expire in ${overdueDays} days , please `}
          <Link
            className={styles.link}
            href='/user/profile?isShowModifyPasswordDialog=true'>
            change
          </Link>{' '}
          it .
        </span>
      </div>
      <span onClick={hideOverduePrompt}>
        <img src={cancelIcon} alt={cancelIcon} className={styles.cancel} />
      </span>
    </div>
  );
};

OverduePrompt.propTypes = {
  overdueDays: PropTypes.number.isRequired,
  isShowOverduePrompt: PropTypes.bool.isRequired,
  isLogin: PropTypes.bool.isRequired,
  toggleOverduePrompt: PropTypes.func.isRequired
};

export default OverduePrompt;
